import * as core from 'zod/v4/core'
import { ZodError } from 'zod'

type ZodIssue = core.$ZodIssue

const formatZodIssue = (issue: ZodIssue): string => {
  const fieldPath = issue.path.join('.')

  let message: string
  switch (issue.code) {
    case 'invalid_type': {
      const received = core.util.parsedType(issue.input)
      message = `Erwarteter Typ: ${issue.expected}, aber erhalten: ${received}.`
      break
    }
    case 'invalid_value':
      message = `Erwarteter Typ: ${issue.values.join(' | ')}, aber erhalten: ${core.util.parsedType(issue.input)}.`
      break
    case 'too_small':
      message = `Wert ist zu klein. Mindestens erforderlich: ${issue.minimum}.`
      break
    case 'too_big':
      message = `Wert ist zu groß. Höchstens zulässig: ${issue.maximum}.`
      break
    case 'invalid_format':
      message = 'Ungültiges Format.'
      break
    default:
      message = 'Ungültiger Wert.'
      break
  }

  return `Fehler in Feld "${fieldPath}": ${message}`
}

export const formatZodError = (zodError: ZodError): string => {
  const extractIssues = (issue: ZodIssue): string[] => {
    if (issue.code === 'invalid_union') {
      if ('errors' in issue) {
        return issue.errors.flat().map(formatZodIssue)
      }
    }
    return [formatZodIssue(issue)]
  }

  return zodError.issues.flatMap(extractIssues).join(' ')
}
